module.exports = __webpack_public_path__ + "static/img/discussion_01_bg.afbcffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/discussion_01_bg.png
// module id = ZtvP
// module chunks = 0